import { Check, X } from "lucide-react";

const ROWS = [
  { label: "Legal, registered ownership of real estate", coown: true, timeshare: false },
  { label: "Appreciating asset · benefits from market growth", coown: true, timeshare: false },
  { label: "Co‑owners hand‑matched on values, budget and lifestyle", coown: true, timeshare: false },
  { label: "Clear constitution covering rotation, exit, succession", coown: true, timeshare: false },
  { label: "Rental income from your unused weeks", coown: true, timeshare: false },
  { label: "A fixed block of one week, year after year", coown: false, timeshare: true },
  { label: "Depreciating product with limited resale", coown: false, timeshare: true },
];

export default function Comparison() {
  return (
    <section
      data-testid="comparison-section"
      className="relative bg-[var(--bone-soft)] text-[var(--ink)]"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] py-24 md:py-36 lg:py-40">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28 reveal">
            <div className="text-overline text-[var(--ink)]/55 mb-6">Why this is different</div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight">
              This is not a timeshare. <span className="italic text-[var(--gold)]">It’s a home.</span>
            </h2>
            <p className="mt-7 text-[var(--ink)]/70 font-light text-base md:text-lg leading-relaxed max-w-md">
              Timeshares sell access. We deliver title. The structure, the legal framework
              and the people sitting alongside you are what make the difference.
            </p>
          </div>

          <div className="lg:col-span-7 reveal">
            <div className="border border-[var(--border-soft)] bg-[var(--bone)] divide-y divide-[var(--border-soft)]">
              <div className="grid grid-cols-[1fr_6.5rem_6.5rem] md:grid-cols-[1fr_8rem_8rem] items-center px-5 md:px-8 py-4 md:py-5">
                <div className="text-overline text-[var(--ink)]/50">Feature</div>
                <div className="text-overline text-[var(--ink)]/80 text-center">Co‑Own</div>
                <div className="text-overline text-[var(--ink)]/40 text-center">Timeshare</div>
              </div>
              {ROWS.map((row, i) => (
                <div
                  key={i}
                  data-testid={`compare-row-${i}`}
                  className="grid grid-cols-[1fr_6.5rem_6.5rem] md:grid-cols-[1fr_8rem_8rem] items-center px-5 md:px-8 py-5 md:py-6"
                >
                  <div className="pr-3 text-[var(--ink)]/85 text-sm md:text-base font-light">
                    {row.label}
                  </div>
                  <div className="flex justify-center">
                    {row.coown ? (
                      <Check className="h-5 w-5 text-[var(--gold)]" strokeWidth={2.25} />
                    ) : (
                      <X className="h-5 w-5 text-[var(--ink)]/25" />
                    )}
                  </div>
                  <div className="flex justify-center">
                    {row.timeshare ? (
                      <Check className="h-5 w-5 text-[var(--ink)]/40" />
                    ) : (
                      <X className="h-5 w-5 text-[var(--ink)]/25" />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
